import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import ChangePassword from "@/pages/ChangePassword";
import AppDetail from "@/pages/AppDetail";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-screen bg-ink" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && location.pathname !== "/trocar-senha")
    return <Navigate to="/trocar-senha" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/conta" replace />;
  return children;
}

function App() {
  useEffect(() => { document.title = "JeaxLabs · Soluções em Software"; }, []);
  return (
    <div className="App grain min-h-screen bg-ink text-white">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/app/:id" element={<AppDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/trocar-senha" element={<Protected><ChangePassword /></Protected>} />
              <Route path="/painel" element={<Protected adminOnly><Admin /></Protected>} />
              <Route path="/conta" element={<Protected><Account /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
